var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1919.463,
    height: 148.135,
    viewBox: "0 0 1919.463 148.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_6",
    "data-name": "Intersection 6",
    d: "M3.993,1417.114v-3.276c.584-.185,1.046-.286,1.046-.286s-.214-51.123-.554-133.561H1923.456c-.008,16.114-.011,30.447-.009,42.782-133.35-5.011-283.317-7.457-435.848-2.663-513.568,16.143-592.14,107.568-1071.715,108.006-6.908.006-13.731.009-20.413.009C85.511,1428.126,16.383,1421.428,3.993,1417.114Z",
    transform: "translate(-3.993 -1279.991)",
    fill: "#dcef94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.f41e37278f1f3cebaebbf6fcf8d73e2d.svg";
export { ForwardRef as ReactComponent };